import type { Recht } from '../api/anmeldung';

/** Die Rollen des Vertriebs (Auftrag CRM-185). Leitung und Innendienst sind seit ÄA-01 stillgelegt, zählen aber mit. */
const VERTRIEBSROLLEN: ReadonlySet<string> = new Set(['vertrieb', 'vertriebsleitung', 'innendienst']);

/**
 * MIT WELCHEM POSTFACH DER POSTEINGANG BEGINNT (Auftrag CRM-185).
 *
 * Wie die Kundenliste im Service auf Privatkunden steht: eine Vorbelegung und
 * kein Filter. Wer Vertrieb, Vertriebsleitung oder Innendienst ist und nicht
 * Service, beginnt im Postfach Vertrieb, alle anderen in Info. Jeder Reiter
 * bleibt wählbar, und ein gezielter Sprung (`postfach` in der Maske) geht vor.
 *
 * Die Rollen kommen aus den WIRKSAMEN RECHTEN wie die Rolle beim Benutzer im
 * Rahmen; eine Vertretung und ein Zusatzrecht machen niemanden zum Vertrieb.
 */
export function postfachVorbelegung(rechte: readonly Recht[]): 'VERTRIEB' | 'ALLGEMEIN' {
  const rollen = new Set(
    rechte
      .flatMap((r) => r.ausRollen)
      .filter((r) => !r.startsWith('vertretung:') && r !== 'zusatzrecht'),
  );
  const vertrieb = [...rollen].some((r) => VERTRIEBSROLLEN.has(r));
  return vertrieb && !rollen.has('service') ? 'VERTRIEB' : 'ALLGEMEIN';
}
